import { render, staticRenderFns } from "./detailsCard.vue?vue&type=template&id=4cb034fc&scoped=true"
import script from "./detailsCard.vue?vue&type=script&lang=js"
export * from "./detailsCard.vue?vue&type=script&lang=js"
import style0 from "./detailsCard.vue?vue&type=style&index=0&id=4cb034fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb034fc",
  null
  
)

export default component.exports